import { lazy } from "react";
import { PATHS } from "@/lib/router";

const MoreSolutionsPage = lazy(() => import("./pages/MoreSolutionsPage"));

export const moreSolutionsRoutes = [
  {
    path: PATHS.MORE_SOLUTIONS,
    element: <MoreSolutionsPage />,
    handle: {
      permission: { resource: "onboard_setup", action: "view" },
      companyFeatureFlag: "moreSolutionsEnabled",
    },
  },
];
